// extracted by mini-css-extract-plugin
module.exports = {"guests":"Guests_guests__1lIA3","active":"Guests_active__1Zv8m","button":"Guests_button__pla_5","body":"Guests_body__tyQEU","counter":"Guests_counter__2eaSH"};